// Sends form data to Formspree. Each form type has its own endpoint, set in .env:
//   REACT_APP_FORMSPREE_CONTACT  - contact page and quote requests
//   REACT_APP_FORMSPREE_AUDIT    - free audit page
// Without an endpoint, falls back to opening the visitor's email client so the
// enquiry is never silently dropped.
const CONTACT_EMAIL = 'info@fedigmaforge.com';

const ENDPOINTS = {
  contact: process.env.REACT_APP_FORMSPREE_CONTACT,
  audit: process.env.REACT_APP_FORMSPREE_AUDIT
};

export const submitForm = async (subject, fields, form = 'contact') => {
  const endpoint = ENDPOINTS[form];

  if (endpoint) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ _subject: subject, ...fields })
    });
    if (!response.ok) {
      throw new Error('Submission failed');
    }
    return 'sent';
  }

  const body = Object.entries(fields)
    .filter(([, value]) => value)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');
  window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return 'mailto';
};
